import InitialState from './initial-state';
import appData from './app-data/reducer';
import appUI from './app-ui/app-ui-reducer';
import breadcrumbs from './breadcrumb/breadcrumbs-reducer';
import casinoStrip from './casino-games/reducer';
import enhancedSpecials from './enhanced-specials/reducer';
import externalContent from './external-content/external-content-reducer';
import favoritesStrip from './favorites/reducer';
import highlightsStrip from './highlights-strip/reducer';
import homePage from './home/home-reducer';
import kambiWidget from './kambi-widget/reducer';
import listView from './list-view/list-view-reducer';
import liveRightNow from './live-right-now/reducer';
import menu from './menu/reducer';
import nextHorseRacing from './next-horse-racing/reducer';
import popular from './popular/reducer';
import recommendedForYou from './recommended-for-you/reducer';
import userContext from './user/user-reducer';
import { combineReducers } from 'redux';
import { i18nReducer } from 'react-redux-i18n';

const rootReducer = combineReducers({
  appConfig: () => InitialState.getState().appConfig,
  appData,
  appUI,
  breadcrumbs,
  casinoStrip,
  enhancedSpecials,
  externalContent,
  favoritesStrip,
  highlightsStrip,
  homePage,
  i18n: i18nReducer,
  kambiWidget,
  listView,
  liveRightNow,
  menu,
  nextHorseRacing,
  popular,
  recommendedForYou,
  userContext
});

export default rootReducer;
